// AutoMapper
import { AutoMap } from '@nartc/automapper';

import { Type } from 'class-transformer';

export class PartyGenderDto {
    @AutoMap() id: number;
    @AutoMap() timeStamp: string;
    @AutoMap() name: string;
    @AutoMap() exactCode?: any;
    @AutoMap() creditManagerCode: string;
    @AutoMap() inactive: boolean;
    @AutoMap() localizableEntry_Id?: any;
    @AutoMap() @Type(() => Date) createdDate: Date;
    @AutoMap() createdBy: string;
    @AutoMap() @Type(() => Date) lastModifiedDate: Date;
    @AutoMap() lastModifiedBy: string;
}